import React from 'react'
import PropTypes from 'prop-types'
import { withTheme } from 'styled-components'
import {
  BlockWrapper,
  StyledAdminHsExplorePrograms,
  StyledExplorePrograms,
  StyledImplementationChecklist,
} from './component.styles'

const AdminHsK8Setup = ({ isLaunched, isSetup, selectedProgram }) => {
  return (
    <BlockWrapper>
      {selectedProgram.name === 'K8' && <StyledExplorePrograms />}
      {selectedProgram.name === 'HS' && <StyledAdminHsExplorePrograms />}
      {isLaunched && isSetup && <StyledImplementationChecklist />}
    </BlockWrapper>
  )
}

AdminHsK8Setup.propTypes = {
  isLaunched: PropTypes.bool,
  isSetup: PropTypes.bool,
  selectedProgram: PropTypes.object,
}

export default withTheme(AdminHsK8Setup)
